import { ClipboardList } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { PublicSurveyTopBar } from './public-survey-top-bar';

export function PublicSurveyUnavailable() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 flex-col bg-background">
      <PublicSurveyTopBar />
      <div className="flex flex-1 flex-col items-center justify-center gap-4 px-4 text-center">
        <div className="grid size-24 place-items-center rounded-2xl bg-muted/50">
          <ClipboardList className="size-10 text-muted-foreground" />
        </div>
        <div className="space-y-2">
          <h2 className="text-lg font-semibold">{t('unavailable.title')}</h2>
          <p className="max-w-md text-sm text-muted-foreground">{t('unavailable.description')}</p>
        </div>
      </div>
    </div>
  );
}
